import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Button from '@/components/ui/Button';
import Card from '@/components/ui/Card';
import sleep from '@/utils/asyncWait';

const ExportPDF = (props) => {
  const { children, redirectUrl } = props;

  const navigate = useNavigate();

  const downloadButtonRef = useRef(null);

  const [counter, setCounter] = useState(5);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    (async () => {
      await sleep(2000);

      if (!downloadButtonRef.current) return;

      downloadButtonRef.current.click();
      setRedirect(true);
    })();
  }, [setRedirect]);

  useEffect(() => {
    if (!redirect) return;

    let interval = setInterval(() => {
      setCounter(counter - 1);

      if (counter > 0) return;

      navigate(redirectUrl);
      clearInterval(interval);
    }, 1000);
  }, [redirect, counter, navigate, redirectUrl]);

  return (
    <Card
      style={{
        width: '100%',
        height: 300,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Button onClick={() => navigate(-1)} style={{ marginRight: 5 }}>
          Retour
        </Button>
        <p style={{ marginTop: 10 }}>
          Votre fichier est en cours de téléchargement. Vous allez être redirigé dans{' '}
          {counter >= 0 ? counter : 0}
        </p>
      </div>
      <p>
        <span>Si le téléchargement ne commence pas automatiquement </span>
        <PDFDownloadLink document={children} fileName="planning.pdf">
          {({ /* blob, url,*/ loading /*, error */ }) =>
            loading ? (
              'Loading document...'
            ) : (
              <>
                <span ref={downloadButtonRef}>{' Cliquez ici'}</span>
              </>
            )
          }
        </PDFDownloadLink>
      </p>
    </Card>
  );
};

export default ExportPDF;
